module.exports = __webpack_public_path__ + "static/opc1-9aca024d15fbd50f033b79c01c6be80f.png";